import { FLIGHT_SEARCH_UNDER_HEADER_HEIGHT, HOTEL_SEARCH_UNDER_HEADER_HEIGHT } from '@frontend/features/common/constants/layout';
import { createContext, useCallback, useState } from 'react';

export type SidebarContextState = {
  isOpen: boolean;
  handleSidebarOpening: () => void;
  headerHeight?: number;
  handleHeaderHeightChange: (height?: number) => void;
  setHasHotelNavSearch: (value: boolean) => void;
  hasNavHotelSearch: boolean;
  setHasFlightsNavSearch: (value: boolean) => void;
  hasNavFlightsSearch: boolean;
};

export const SidebarContext = createContext<SidebarContextState>({} as SidebarContextState);

interface SidebarContextProviderProps {
  children: JSX.Element;
}

export const SidebarContextProvider = ({ children }: SidebarContextProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState<number | undefined>(undefined);
  const [hasNavHotelSearch, setHasHotelNavSearch] = useState(false);
  const [hasNavFlightsSearch, setHasFlightsNavSearch] = useState(false);

  const handleSidebarOpening = useCallback(() => setIsOpen((currentState) => (currentState ? false : true)), [isOpen]);

  const handleHeaderHeightChange = useCallback((height?: number) => {
    let finalHeight = height;
    if (hasNavHotelSearch && height) { finalHeight = height+ HOTEL_SEARCH_UNDER_HEADER_HEIGHT ;}
    else if (hasNavFlightsSearch && height) { finalHeight = height+ FLIGHT_SEARCH_UNDER_HEADER_HEIGHT ;}
    setHeaderHeight(finalHeight)
  }, [hasNavHotelSearch, hasNavFlightsSearch]);

  return (
    <SidebarContext.Provider
      value={{
        isOpen,
        handleSidebarOpening,
        headerHeight,
        handleHeaderHeightChange,
        setHasHotelNavSearch,
        hasNavHotelSearch,
        setHasFlightsNavSearch,
        hasNavFlightsSearch
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
